// extracted by mini-css-extract-plugin
module.exports = {"more":"More_more__1Ocj3","light":"More_light__3Sjzg","dark":"More_dark__DhvzM","iconArrow":"More_iconArrow__88rS7"};